import api from "../interceptor/Interceptor";


const initial = "products"

const CreateProductService = async (formData) => {
    try {
        const response = await api(`${initial}/create-product`, {
            method: 'POST',
            body: formData,
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("some error occurred", error);
    }
}

const UpdateProductService = async (id, formData) => {
    try {
        const response = await api(`${initial}/update-product/${id}`, {
            method: 'Put',
            body: formData,
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("some error occurred", error);
    }
}

const GetAllProductService = async () => {
    try {
        const response = await api(`${initial}/products`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("some error occurred", error);
    }
}

const GetSingleProductService = async (id) => {
    try {
        const response = await api(`${initial}/product/${id}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("some error occurred", error);
    }
}

const DeleteProductByIdService = async (id) => {
    try {
        const response = await api(`${initial}/delete-product/${id}`, {
            method: 'Delete',
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("some error occurred", error);
    }
}

const DiscountAtOnce = async (payload) => {
    try {
        const response = await api(`${initial}/apply-discount`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Some error occurred", error);
    }
};


const GetDiscountAtOnce = async () => {
    try {
        const response = await api(`${initial}/get-discount`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Some error occurred", error);
    }
};


export { CreateProductService, GetAllProductService, UpdateProductService, GetSingleProductService, DeleteProductByIdService, DiscountAtOnce, GetDiscountAtOnce }